import styled from 'styled-components';

export const ToastBox = styled.div<{ $visible: boolean }>`
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translate(-50%, ${({ $visible }) => ($visible ? '0' : '-8px')});
  z-index: 9999;
  background: #1e3820;
  color: #8dca6a;
  padding: 12px 20px;
  border-radius: 9px;
  font-weight: 700;
  font-size: 13px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.5);
  pointer-events: none;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition:
    opacity 0.25s,
    transform 0.25s;
  display: flex;
  align-items: center;
  gap: 10px;
`;
